import { Requirement } from './permissions';

/** Reusable requirements for routes, menu items and in-page checks. */
export const MODERATOR: Requirement = { moderator: true };
export const ORDERS_R: Requirement = { area: 'orderIntegration' };
export const ORDERS_RW: Requirement = { area: 'orderIntegration', level: 'rw' };
export const STORIES_R: Requirement = { area: 'stories' };
export const STORIES_RW: Requirement = { area: 'stories', level: 'rw' };
export const STORY_VIEWER: Requirement = { anyOf: [{ area: 'mediaViewer' }, { area: 'stories' }] };
export const MOCKUP_HISTORY_R: Requirement = { area: 'mockupHistory' };
export const MOCKUP_R: Requirement = { area: 'mockup' };
export const MOCKUP_RW: Requirement = { area: 'mockup', level: 'rw' };
export const AAV_PRODUCTION_R: Requirement = { area: 'aavProduction' };
export const AAV_SHOPIFY_R: Requirement = { area: 'aavShopify' };
